import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'

export const GET_ARTIST_REQUEST = 'GET_ARTIST_REQUEST'
export const GET_ARTIST_SUCCESS = 'GET_ARTIST_SUCCESS'
export const GET_ARTIST_ERROR = 'GET_ARTIST_ERROR'
export const getArtist = (id, offset, limit) => dispatch => {
	dispatch({ type: GET_ARTIST_REQUEST })
	// fetch infos et albums
	return api.getArtist(id, 'albums', offset, limit)
		.then(responseInfos => {
			if (responseInfos.status === 'error') {
				dispatch(push('/'))
				dispatch({ type: GET_ARTIST_ERROR, responseInfos })
			} else {
				// fetch top tracks
				return api.getArtist(id, 'playlists', 0, 5)
					.then(responseTopTracks => {
						if (responseTopTracks.status === 'error') {
							dispatch(push('/'))
							dispatch({ type: GET_ARTIST_ERROR, responseInfos })
						} else {
							dispatch({
								type: GET_ARTIST_SUCCESS,
								infos: responseInfos,
								albums: responseInfos ? responseInfos.albums : undefined,
								topTracks: responseTopTracks && responseTopTracks.playlists && responseTopTracks.playlists.length ?
									responseTopTracks.playlists[0].tracks :
									undefined
							})
						}
					}
				)
			}
		})
		.catch(e => {
			push('/')
			dispatch({ type: GET_ARTIST_ERROR, e })
		})
}



// WEBPACK FOOTER //
// ./src/pages/artist/artistActions.js